import { LicenseManager } from "ag-grid-enterprise";
import { useContext } from "react";

import { AppDefaultInfoContext } from "helpers/globalContext/AppDefaultInfoContext";

export function AGGridProvider() {
    const appDefaults = useContext(AppDefaultInfoContext);

    LicenseManager.setLicenseKey(appDefaults?.aGGridLicenseKey ?? "");

    return null;
}
